import React, { useEffect } from 'react'
import { Grid, Stack } from '@mui/material'
import { UseFormReturn, useWatch } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { ControlledTextField, AsyncSelect } from "../../../../../components/forms";
import { OperacionNOTESFields } from '../types/fields';
import SeccionNOTESNuevoSeccionCupon from './SeccionNOTESNuevoSeccionCupon'
import SeccionNOTESNuevoRescateAnticipado from './SeccionNOTESNuevoRescateAnticipado'
import SeccionNOTESNuevoSeccionParticipacion from './SeccionNOTESNuevoSeccionParticipacion'
import { useNOTESNotaTipos } from '../hooks/useNOTESCache'
import { useLoadOptions } from 'src/hooks/useLoadOptions'

interface SeccionNuevoNOTESDatosSeccionesProps {
  formMethods: UseFormReturn<any>,
  codPais: number
}

const SeccionNuevoNOTESDatosSecciones = ({ formMethods, codPais }: SeccionNuevoNOTESDatosSeccionesProps) => {
  const { control, setValue } = formMethods

  const notaTipos = useNOTESNotaTipos(codPais);
  const loadNotaTipos = useLoadOptions({
    data: notaTipos.notaTipos,
    loading: notaTipos.isLoading,
    isError: notaTipos.isError,
    error: notaTipos.error
  });

  const watchTipoNota = useWatch({
    control,
    name: OperacionNOTESFields.TipoNota
  });

  useEffect(() => {
    if (notaTipos.notaTipos.length === 1 && !watchTipoNota) {
      setValue(OperacionNOTESFields.TipoNota, notaTipos.notaTipos[0].id, { shouldDirty: true, shouldValidate: true });
    }
  }, [notaTipos.notaTipos, watchTipoNota, setValue]);

  return (
    <Stack gap={2}>
      <CardActions title='Sección - Información General' icon='mdi:information-outline' colapsable>
        <SectionBox>
          <Grid item xs={4} >
            <AsyncSelect label='Tipo de Nota' loadOptions={loadNotaTipos} name={OperacionNOTESFields.TipoNota} control={control} fullWidth selectNotNulleable />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Moneda' name={OperacionNOTESFields.Moneda} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Vencimiento' name={OperacionNOTESFields.Vencimiento} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Emisor' name={OperacionNOTESFields.Emisor} control={control} fullWidth />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Sub-yacentes' icon='mdi:chart-scatter-plot' colapsable>
        <SectionBox>
          <Grid item xs={12}>
            <ControlledTextField label='Subyacentes' name={OperacionNOTESFields.Subyacentes} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsSubyacentes} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <SeccionNOTESNuevoSeccionCupon formMethods={formMethods} />

      <SeccionNOTESNuevoRescateAnticipado formMethods={formMethods} />

      <SeccionNOTESNuevoSeccionParticipacion formMethods={formMethods} />


      <CardActions title='Sección Protección o Garantía de Capital' icon='mdi:shield-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} >
            <ControlledTextField label='Tipo de protección' name={OperacionNOTESFields.TipoProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Nivel de protección' name={OperacionNOTESFields.NivelProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} >
            <ControlledTextField label='Descripción de la protección' name={OperacionNOTESFields.DescripcionProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsProteccion} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>


    </Stack>
  )
}

export default SeccionNuevoNOTESDatosSecciones
